@if (label) {
  <app-control-header
    [label]="label"
    [labelParamsObj]="labelParamsObj"
    [infoTooltip]="infoTooltip"
    [infoTooltipPlacement]="infoTooltipPlacement"
    [index]="index"
    [required]="required"
    [labelWithColon]="labelWithColon"
    [descriptionTooltipText]="descriptionTooltipText"
  ></app-control-header>
}

<div class="wrapper w-full" [class.pointer-events-none]="isDisabled$ | async">
  @if (!hasValue && !isActive) {
    <app-control-placeholder
      class="absolute"
      [placeholder]="placeholder"
      [placeholderParamsObj]="placeholderParamsObj"
      [placeholderIcon]="placeholderIcon"
      (click)="placeholderClick()"
    ></app-control-placeholder>
  }

  <textarea
    #textField
    class="textarea"
    id="{{ fieldName }}-textfield"
    [style.min-height.px]="minTextareaHeight"
    [class.resize-none]="autogrow || !resizable"
    [class.h-10]="!(rows >= 1) && !autogrow"
    [class.overflow-hidden]="autogrow"
    [ngModel]="value"
    [class.rows-specified]="rows > 1"
    [disabled]="isDisabled$ | async"
    [attr.maxLength]="maxLength ? maxLength : -1"
    [readonly]="readonly"
    [rows]="rows"
    [attr.data-test-id]="'input'"
    (blur)="inputBlur()"
    (ngModelChange)="modelChange($event)"
    (change)="modelChange(textField.value)"
    (input)="input.emit($event)"
    (focusin)="inputFocusIn()"
    (focusout)="inputFocusOut()"
  ></textarea>

  <!-- This div overlays text area and this allows highlighting syntax. -->
  <!-- see here: https://codepen.io/nathank/pen/LEBddV and here: https://codepen.io/nathank/pen/LEBddV -->
  @if (getHighlightedSyntax(); as tokens) {
    <div
      data-test-id="highlight-container"
      class="border-transparent text-backdrop w-full h-full absolute top-0 left-0 z-0 pointer-events-none whitespace-pre-wrap break-words text-transparent overflow-y-scroll"
    >
      @for (textPart of tokens; track $index) {
        @switch (textPart.type) {
          @case ('term') {
            <span data-test-id="highlighted" class="text-blue-70">{{ textPart.value }}</span>
          }

          @default {
            <span>{{ textPart.value }}</span>
          }
        }
      }
    </div>
  }

  <div class="buttons">
    <ng-content select="app-button"></ng-content>

    @if (removable) {
      <button class="remove-contol-button" (click)="removeControl.emit(fieldName)">
        <svg-icon src="close"></svg-icon>
      </button>
    }
  </div>
</div>

<div class="flex justify-end items-center">
  @if (displayErrors && errorsDisplayed) {
    <app-control-errors class="flex-1" [errorTexts]="errorTexts"></app-control-errors>
  }

  @if (displayCharactersCounter) {
    <app-characters-counter [value]="value" [maxLength]="maxLength"></app-characters-counter>
  }
</div>
